import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { ControlTowerStateModel } from '@control-tower/store/models/control-tower-state.model';
import { NotificationService } from '@core/services/notification/notification.service';
import { Store } from '@ngxs/store';

export const guestOnlyControlTowerGuard: CanActivateChildFn = (_route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  const controlTowerState = store.selectSnapshot<ControlTowerStateModel>(s => s['controlTower']);
  const isGuest = controlTowerState?.userType === 'GUEST';

  if (!isGuest) {
    return true;
  }

  const currentUrl = state.url ?? '';
  const urlPath = currentUrl.split('?')[0]; // Remove query parameters for route checking
  const isControlTowerRoute = urlPath.includes('/control-tower') || urlPath.includes('control-tower');
  const isDsrRoute = urlPath.includes('/daily-status-report') || urlPath.includes('daily-status-report');
  if (isControlTowerRoute || isDsrRoute) {
    return true;
  }

  notificationService.showError('Guest access is limited to Control Tower and Daily Status Report modules.');
  const controlTowerId: string | undefined = controlTowerState?.controlTowerId;
  return controlTowerId ? router.createUrlTree(['/control-tower', controlTowerId]) : false;
};
